export const CODE_LENGTH = 6;

export const MINUTE = 60000;

export const FORM_NAME = 'MultiFactorAuth';
